module.exports = __webpack_public_path__ + "img/index2.483768f1.png";